import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Input } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css'],
})
export class DateComponent {
  openDateNotified: any;
  //date: NgbDate = new NgbDate(1789, 7, 14);
  date: NgbDate;
  dateArray: any = [];
  @Output() dateSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() product: any = [];
  @Input() type: string = '';
  @Input() productId: string = '';
  @Input() inputDate: '';
  selectedDate: NgbDate;

  ngOnInit() {
    this.splitDate(this.inputDate);
  }

  onDateSelect(event: NgbDate) {
    this.selectedDate = event;
  }

  splitDate(inputDate: string) {
    if (inputDate) {
      this.dateArray = inputDate.split('-');
      this.date = new NgbDate(
        parseInt(this.dateArray[0]),
        parseInt(this.dateArray[1]),
        parseInt(this.dateArray[2])
      );
      this.selectedDate = this.date;
    }
  }

  saveDate() {
    this.dateSelected.emit({
      event: this.selectedDate,
      productId: this.productId,
      type: this.type,
    });
  }
}
